import { handleActions } from 'redux-actions';
import { types } from '../constants';

const INITIAL_STATE = {
  coursesByBranch: {
    items: [],
    itemsCopy: [],
    isLoading: false,
    errorMessage: '',
    searchTerm: ''
  },
  coursesByCompany: {
    items: [],
    isLoading: false,
    errorMessage: ''
  },
  deleteCourse: {
    openDialog: false,
    course: null,
    isSaving: false,
    errorMessage: false
  },
  courseRecordsByBranch: {
    items: [],
    isLoading: false,
    errorMessage: ''
  },
  courseRecordsByCompany: {
    items: [],
    isLoading: false,
    errorMessage: ''
  }
};

const startFetchAllCoursesForBranch = (state) => {
  return {
    ...state,
    coursesByBranch: {
      ...state.coursesByBranch,
      isLoading: true
    }
  };
};

const fetchAllCoursesForBranchSuccess = (state, { courses }) => {
  return {
    ...state,
    coursesByBranch: {
      ...state.coursesByBranch,
      items: courses,
      itemsCopy: courses
    }
  };
};

const fetchAllCoursesForBranchFailure = (state, { errorMessage }) => {
  return {
    ...state,
    coursesByBranch: {
      ...state.coursesByBranch,
      errorMessage
    }
  };
};

const fetchAllCoursesForBranchFinished = (state) => {
  return {
    ...state,
    coursesByBranch: {
      ...state.coursesByBranch,
      isLoading: false
    }
  };
};

const startFetchAllCoursesForCompany = (state) => {
  return {
    ...state,
    coursesByCompany: {
      ...state.coursesByCompany,
      isLoading: true
    }
  };
};

const fetchAllCoursesForCompanySuccess = (state, { courses }) => {
  return {
    ...state,
    coursesByCompany: {
      ...state.coursesByCompany,
      items: courses,
      itemsCopy: courses
    }
  };
};

const fetchAllCoursesForCompanyFailure = (state, { errorMessage }) => {
  return {
    ...state,
    coursesByCompany: {
      ...state.coursesByCompany,
      errorMessage
    }
  };
};

const fetchAllCoursesForCompanyFinished = (state) => {
  return {
    ...state,
    coursesByCompany: {
      ...state.coursesByCompany,
      isLoading: false
    }
  };
};

const chamgeSearchTermAllCourses = (state, { searchTerm }) => {
  let courses = [...state.coursesByBranch.itemsCopy];
  let filteredCourses = courses.filter(
    (c) =>
      c.unitDescription && c.unitDescription.toLowerCase().includes(searchTerm)
  );

  return {
    ...state,
    coursesByBranch: {
      ...state.coursesByBranch,
      searchTerm,
      items: filteredCourses
    }
  };
};

const submitCourseSuccess = (state, { submittedCourse }) => {
  let courses = [...state.coursesByBranch.items];
  let updatedCourseIndex = courses.findIndex(
    (c) => c.id === submittedCourse.id
  );

  //Means updated
  if (updatedCourseIndex !== -1) {
    courses[updatedCourseIndex] = submittedCourse;
  } else {
    courses = [...courses, submittedCourse];
  }

  return {
    ...state,
    coursesByBranch: {
      ...state.coursessByBranch,
      items: courses,
      itemsCopy: courses
    }
  };
};

const openDeleteCourseDialog = (state, { open, course }) => {
  return {
    ...state,
    deleteCourse: {
      ...state.deleteCourse,
      openDialog: open,
      course: open === true ? course : null
    }
  };
};

const startDeleteCourse = (state) => {
  return {
    ...state,
    deleteCourse: {
      ...state.deleteCourse,
      isSaving: true
    }
  };
};
const deleteCourseSuccess = (state, { courseId }) => {
  var coursesByBranch = state.coursesByBranch.items;
  var filteredCourses = coursesByBranch.filter(
    (course) => course.id !== courseId
  );

  return {
    ...state,
    deleteCourse: {
      ...state.deleteCourse
    },
    coursesByBranch: {
      ...state.coursesByBranch,
      items: filteredCourses
    }
  };
};
const deleteCourseFailure = (state, { errorMessage }) => {
  return {
    ...state,
    coursesByBranch: {
      ...state.coursesByBranch,
      errorMessage
    }
  };
};
const deleteCourseFinished = (state) => {
  return {
    ...state,
    deleteCourse: {
      ...state.deleteCourse,
      isSaving: false
    }
  };
};

const startFetchAllCourseRecordsForBranch = (state) => {
  return {
    ...state,
    courseRecordsByBranch: {
      ...state.courseRecordsByBranch,
      isLoading: true
    }
  };
};

const fetchAllCourseRecordsForBranchSuccess = (state, { courseRecords }) => {
  return {
    ...state,
    courseRecordsByBranch: {
      ...state.courseRecordsByBranch,
      items: courseRecords
    }
  };
};

const fetchAllCourseRecordsForBranchFailure = (state, { errorMessage }) => {
  return {
    ...state,
    courseRecordsByBranch: {
      ...state.courseRecordsByBranch,
      errorMessage
    }
  };
};

const fetchAllCourseRecordsForBranchFinished = (state) => {
  return {
    ...state,
    courseRecordsByBranch: {
      ...state.courseRecordsByBranch,
      isLoading: false
    }
  };
};

const startFetchAllCourseRecordsForCompany = (state) => {
  return {
    ...state,
    courseRecordsByCompany: {
      ...state.courseRecordsByCompany,
      isLoading: true
    }
  };
};

const fetchAllCourseRecordsForCompanySuccess = (state, { courseRecords }) => {
  return {
    ...state,
    courseRecordsByCompany: {
      ...state.courseRecordsByCompany,
      items: courseRecords
    }
  };
};

const fetchAllCourseRecordsForCompanyFailure = (state, { errorMessage }) => {
  return {
    ...state,
    courseRecordsByCompany: {
      ...state.courseRecordsByCompany,
      errorMessage
    }
  };
};

const fetchAllCourseRecordsForCompanyFinished = (state) => {
  return {
    ...state,
    courseRecordsByCompany: {
      ...state.courseRecordsByCompany,
      isLoading: false
    }
  };
};

//Handles the incoming actions.
export default handleActions(
  {
    [types.START_FETCH_ALL_COURSES_FOR_BRANCH]: startFetchAllCoursesForBranch,
    [types.FETCH_ALL_COURSES_FOR_BRANCH_SUCCESS]: fetchAllCoursesForBranchSuccess,
    [types.FETCH_ALL_COURSES_FOR_BRANCH_FAILURE]: fetchAllCoursesForBranchFailure,
    [types.FETCH_ALL_COURSES_FOR_BRANCH_FINISHED]: fetchAllCoursesForBranchFinished,

    [types.START_FETCH_ALL_COURSES_FOR_COMPANY]: startFetchAllCoursesForCompany,
    [types.FETCH_ALL_COURSES_FOR_COMPANY_SUCCESS]: fetchAllCoursesForCompanySuccess,
    [types.FETCH_ALL_COURSES_FOR_COMPANY_FAILURE]: fetchAllCoursesForCompanyFailure,
    [types.FETCH_ALL_COURSES_FOR_COMPANY_FINISHED]: fetchAllCoursesForCompanyFinished,

    [types.CHANGE_SEARCH_TERM_ALL_COURSES]: chamgeSearchTermAllCourses,

    [types.SUBMIT_COURSE_SUCCESS]: submitCourseSuccess,

    [types.OPEN_DELETE_COURSE_DIALOG]: openDeleteCourseDialog,

    [types.START_DELETE_COURSE]: startDeleteCourse,
    [types.DELETE_COURSE_SUCCESS]: deleteCourseSuccess,
    [types.DELETE_COURSE_FAILURE]: deleteCourseFailure,
    [types.DELETE_COURSE_FINISHED]: deleteCourseFinished,

    [types.START_FETCH_ALL_COURSE_RECORDS_FOR_BRANCH]: startFetchAllCourseRecordsForBranch,
    [types.FETCH_ALL_COURSE_RECORDS_FOR_BRANCH_SUCCESS]: fetchAllCourseRecordsForBranchSuccess,
    [types.FETCH_ALL_COURSE_RECORDS_FOR_BRANCH_FAILURE]: fetchAllCourseRecordsForBranchFailure,
    [types.FETCH_ALL_COURSE_RECORDS_FOR_BRANCH_FINISHED]: fetchAllCourseRecordsForBranchFinished,

    [types.START_FETCH_ALL_COURSE_RECORDS_FOR_COMPANY]: startFetchAllCourseRecordsForCompany,
    [types.FETCH_ALL_COURSE_RECORDS_FOR_COMPANY_SUCCESS]: fetchAllCourseRecordsForCompanySuccess,
    [types.FETCH_ALL_COURSE_RECORDS_FOR_COMPANY_FAILURE]: fetchAllCourseRecordsForCompanyFailure,
    [types.FETCH_ALL_COURSE_RECORDS_FOR_COMPANY_FINISHED]: fetchAllCourseRecordsForCompanyFinished
  },
  INITIAL_STATE
);
